import { Accordion, AccordionDetails, AccordionSummary, Box, List, ListItem, Typography } from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import TrombiLink from '../commun/TrombiLink'

export default function FaqContact() {
  document.title = "FAQ - Contact | Annuaire de l'Insee"

  return (
    <Box sx={{ p: 4 }}>
      <Typography
        variant="h4"
        component="h2"
        style={{ fontWeight: 'bold' }}
      >
        FAQ / Contact
      </Typography>

      <br />
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography
            variant="h6"
            component="h3"
            style={{ fontWeight: 'bold' }}
          >
            D’où proviennent les informations de l’annuaire des personnes et des services ?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography
            variant="body1"
            component="p"
          >
            Les informations proviennent majoritairement de Sirhius et sont fournies par APIRH avec un retard d’une
            journée. C’est le cas des caractéristiques de l’agent (affectation, grade, fonction…), des informations de
            contact (hors adresse mail) et de la description des unités d’affectation des agents (timbre, adresse…).
            <br />
            <br />
            L’adresse mail est issue de l’annuaire général ou de Sirhius selon la situation administrative de l’agent.
            <br />
            <br />
            La photo est récupérée de l’intranet Symphonie.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography
            variant="h6"
            component="h3"
            style={{ fontWeight: 'bold' }}
          >
            Comment mettre à jour ma photo ?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography
            variant="body1"
            component="p"
          >
            Pour modifier la photo associée à un agent sur l’intranet Symphonie donc sur le trombi, suivez ce{' '}
            <TrombiLink href="https://intranet.insee.fr/jcms/5070336_DBWikiPage/fr/3-comprendre-le-profil#5070336_DBWikiPage_content_toc_2_2">
              tutoriel
            </TrombiLink>
            .
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography
            variant="h6"
            component="h3"
            style={{ fontWeight: 'bold' }}
          >
            Comment mettre à jour mes informations personnelles ?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography
            variant="body1"
            component="p"
          >
            Votre <b>téléphone fixe professionnel</b> et votre <b>bureau</b> sont à modifier dans le portail agent de
            Sirhius, rubrique « Modifier mes données ».
            <br />
            <br />
            Pour le numéro de <b>téléphone portable professionnel</b> :
          </Typography>
          <List>
            <ListItem sx={{ display: 'inherit' }}>
              • Si vous n’avez pas renseigné de numéro de portable professionnel dans Sirhius mais que vous disposez
              d'un téléphone <b>portable professionnel fourni par l'administration</b>, c'est ce numéro de téléphone qui
              est affiché : en cas d'erreur, veuillez contacter votre assistance informatique locale, qui en gère
              l’attribution.
            </ListItem>
            <ListItem>
              • Dans tous les cas, si vous avez saisi un numéro téléphone portable professionnel dans Sirhius, c'est ce
              numéro qui est affiché (que vous disposiez ou non d'un portable fourni par l'administration).
            </ListItem>
          </List>
          <Typography
            variant="body1"
            component="p"
          >
            Si vous n’avez pas accès à Sirhius ou si vous êtes gérés par une autre direction du ministère,{' '}
            <TrombiLink href="https://intranet.insee.fr/jcms/14466970_DBFileDocument/fr/plaquette-csrh-agents-eloignes-du-service">
              contactez le CSRH
            </TrombiLink>
            .
            <br />
            <br />
            Si l’<b>adresse mail professionnelle</b> affichée dans l’annuaire est erronée, contactez la division
            « Valorisation des données du Secrétariat Général (DVDSG) » ({''}
            <TrombiLink href="mailto:dg75-sirh@insee.fr">dg75-sirh@insee.fr</TrombiLink>
            ). <br />
            <br />
            Les demandes de modification de la <b>fonction</b> et de la qualité de <b>responsable</b> sont à adresser à
            votre unité RH locale qui s’adressera au CSRH concerné.
            <br />
            <br />
            Les <b>adresses mail des boîtes fonctionnelles</b> (BALF) sont le reflet des boîtes sur lesquelles vous avez
            des droits d’accès :
          </Typography>
          <List>
            <ListItem>
              • si une BALF apparaît à tort : il faut demander la suppression de vos droits, qui sont peut-être restés
              en place malgré une mobilité ;
            </ListItem>
            <ListItem>
              • si une BALF n’apparaît pas mais que vous y accédez : c’est a priori que son propriétaire a fait le choix
              de la masquer.
            </ListItem>
          </List>
          <Typography
            variant="body1"
            component="p"
          >
            C’est le propriétaire de chaque BALF qui valide les changements de droits sur ses BALF, et qui choisit de
            les rendre visibles ou non dans l’annuaire.
            <br />
            <br />
            Vous pouvez faire vous-même une demande de modification de droits via Si@Moi : dans la barre de recherche,
            tapez « BALF », vous aurez toutes les demandes associées aux BALF et vous trouverez les demandes d’ajout et
            de suppressions de droits d’accès.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography
            variant="h6"
            component="h3"
            style={{ fontWeight: 'bold' }}
          >
            Comment mettre à jour les informations sur les unités ?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography
            variant="body1"
            component="p"
          >
            En cas de mise à jour portant sur une unité de l’Insee, vous devez vous rapprocher de votre unité RH locale,
            qui pourra faire une demande à la division « Valorisation des données du Secrétariat Général (DVDSG) » selon
            le circuit de gestion habituel.
            <br />
            <br />
            En cas de mise à jour portant sur une unité hors Insee, vous devez vous rapprocher de la division Mobilités
            et Encadrement (DME).
          </Typography>
        </AccordionDetails>
      </Accordion>

      <br />
      <Typography
        variant="h6"
        component="h3"
        style={{ fontWeight: 'bold' }}
      >
        Pour toute autre question ou remarque, contactez la division « Valorisation des données du Secrétariat
        Général (DVDSG) » ({''}
        <TrombiLink href="mailto:dg75-sirh@insee.fr">dg75-sirh@insee.fr</TrombiLink>)
      </Typography>
    </Box>
  )
}
